<template>
  <div>
    <!-- <span style="font-size: 18px; font-weight: bold">意見調查滿意度（整團平均分數）</span> -->
    <div style="display: flex; justify-content: space-between; align-items: center">
      <span style="font-size: 18px; font-weight: bold">意見調查滿意度（整團平均分數）</span>
      <router-link to="/agency/agencyOpinionSurvey/index">
        <el-button size="mini" icon="el-icon-arrow-right" circle text></el-button>
      </router-link>
    </div>

    <el-card class="box-card-component" style="margin-top: 8px">
      <!-- <div slot="header" class="box-card-header">
      <img src="https://wpimg.wallstcn.com/e7d23d71-cf19-4b90-a1cc-f56af8c0903d.png">
    </div> -->
      <div style="position: relative; height: 272px">
        <!-- <pan-thumb :image="avatar" class="panThumb" /> -->
        <!-- <mallki class-name="mallki-text" text="意見調查滿意度" /> -->

        <div
          style="height: 100%; overflow: auto"
          v-if="statisticsData && statisticsData.length > 0"
        >
          <div class="progress-item" v-for="(item, index) in statisticsData" :key="index">
            <div>
              <span>{{ item.travelName }}</span>
              <el-progress
                :percentage="item.analysis"
                :color="customColorMethod"
                :format="formatValue"
              />
            </div>
          </div>
          <!-- <div class="progress-item">
          <span>滿意</span>
          <el-progress :percentage="12" :format="formatValue" />
        </div>
        <div class="progress-item">
          <span>普通</span>
          <el-progress
            :percentage="100"
            status="success"
            :format="formatValue"
          />
        </div>
        <div class="progress-item">
          <span>不太滿意</span>
          <el-progress
            :percentage="100"
            status="success"
            :format="formatValue"
          />
        </div>
        <div class="progress-item">
          <span>非常不滿意</span>
          <el-progress
            :percentage="100"
            status="success"
            :format="formatValue"
          />
        </div> -->
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PanThumb from '@/components/PanThumb'
import Mallki from '@/components/TextHoverEffect/Mallki'

export default {
  components: { PanThumb, Mallki },
  props: {
    surveyAnalysis: {
      type: Array,
      default: () => [],
    },
  },
  filters: {},
  watch: {
    surveyAnalysis: {
      handler: function (newVal, oldVal) {
        this.statisticsData = newVal
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      statisticsData: [],
    }
  },
  computed: {
    ...mapGetters(['name', 'avatar', 'roles']),
  },
  created() {
    if (!this.surveyAnalysis) return
    this.statisticsData = this.surveyAnalysis
  },
  methods: {
    formatValue(val) {
      let r = 0
      if (val > 0) {
        //將百分比換算1/5，公式 val /100 /0.2
        r = parseFloat((val / 100 / 0.2).toFixed(2))
      }
      return r
    },
    customColorMethod(percentage) {
      if (percentage == 0) return '#ccc'
      let r = percentage / 100 / 0.2
      if (r <= 3) {
        return '#E16D6D'
      } else if (r <= 4) {
        return '#F9DE5D'
      } else {
        return '#7EC050'
      }
    },
  },
}
</script>

<style lang="scss">
.box-card-component {
  .el-card__header {
    padding: 0px !important;
  }
}
</style>
<style lang="scss" scoped>
.box-card-component {
  .box-card-header {
    position: relative;
    height: 220px;
    img {
      width: 100%;
      height: 100%;
      transition: all 0.2s linear;
      &:hover {
        transform: scale(1.1, 1.1);
        filter: contrast(130%);
      }
    }
  }
  .mallki-text {
    position: absolute;
    top: 0px;
    left: 0px;
    font-size: 20px;
    font-weight: bold;
  }
  .panThumb {
    z-index: 100;
    height: 70px !important;
    width: 70px !important;
    position: absolute !important;
    top: -45px;
    left: 0px;
    border: 5px solid #ffffff;
    background-color: #fff;
    margin: auto;
    box-shadow: none !important;
    ::v-deep .pan-info {
      box-shadow: none !important;
    }
  }
  .progress-item {
    margin-bottom: 10px;
    font-size: 14px;
  }
  @media only screen and (max-width: 1510px) {
    .mallki-text {
      display: none;
    }
  }
}
</style>
